var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueApexCharts',{attrs:{"type":"pie","options":_vm.pieChart.options,"series":_vm.pieChart.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }